<template>
	<div class="calendar-container" :class="{ toggable: toggable }">
		<header @click="toggleContent">
			<div class="title-wrapper" :tutorial-id="useTutorialId">
				<template :aria-hidden="showTutorial">
					<h1 class="heading-5">{{ title }}</h1>
					<h2
						v-if="!containerOnly"
						class="body-text-1"
						:class="{ 'border-text': onBorderText }"
						:name="title"
					>
						{{ subtitle }}: {{ amountSpent | currency }}
					</h2>
				</template>

				<ja-tooltip
					v-if="showOnboarding"
					ref="tooltip"
					class="tooltip left"
					:pointer="true"
					tabindex="0"
					aria-activedescendant="text-tooltip-2"
				>
					<h1 id="text-tooltip-2" class="body-text-1">
						{{ $t('calendarОnboardingSavings') }}
					</h1>
					<ja-button
						class="small transparent"
						name="drag-help"
						:aria-label="$t('goNextOnboardingStep')"
						@click.native="continueOnboarding"
						>{{ $t('next') }}</ja-button
					>
				</ja-tooltip>
			</div>
			<div class="icon-wrapper"></div>
			<svgicon
				v-if="toggable"
				name="arrow-down"
				class="icon--x-large icon--primary"
				:class="{ 'icon--rotate-180': isContentVisible }"
			></svgicon>
		</header>
		<div
			class="container-content"
			:class="{ 'toggable--open': toggable && isContentVisible }"
			:aria-hidden="showOnboarding"
		>
			<slot></slot>
		</div>
	</div>
</template>
<script>
import Button from '../ui/Button';
import Tooltip from '../ui/Tooltip';
export default {
	components: {
		jaButton: Button,
		jaTooltip: Tooltip
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		subtitle: {
			type: String,
			default: ''
		},
		amountSpent: {
			type: Number,
			default: 0
		},
		showOnboarding: {
			type: Boolean,
			default: false
		},
		containerOnly: {
			type: Boolean,
			default: false
		},
		toggable: {
			type: Boolean,
			default: false
		},
		collapsed: {
			type: Boolean,
			default: false
		},
		useTutorialId: {
			type: String,
			default: ''
		},
		onBorderText: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isContentVisible: true
		};
	},
	watch: {
		collapsed(value) {
			this.isContentVisible = !value;
		}
	},
	updated() {
		if (this.showOnboarding) {
			this.$refs.tooltip.$el.focus();
		}
	},
	mounted() {
		this.isContentVisible = !this.collapsed;
	},
	methods: {
		continueOnboarding() {
			this.$emit('continueOnboarding');
		},
		toggleContent() {
			if (this.toggable) {
				this.isContentVisible = !this.isContentVisible;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.calendar-container {
	width: 100%;

	&.toggable {
		header {
			cursor: pointer;
		}

		.container-content {
			display: none;

			&.toggable--open {
				display: flex;
			}
		}
	}

	header {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 60px;
		padding: 0 16px;
		border-radius: 6px 6px 0 0;
		background-color: rgba(200, 207, 227, 0.5);

		.title-wrapper {
			position: relative;
			.heading-5 {
				color: #000000;
				margin-top: 0;
				margin-bottom: 4px;
			}

			.body-text-1 {
				margin: 0;
			}
			.border-text {
				border: 2px solid $btn-career-selected;
				padding: 0 5px 0 5px;
				color: $btn-career-selected;
			}
			.tooltip {
				z-index: 99;
				width: 300px;
				height: fit-content;
				text-align: center;
				padding: 24px 24px 16px 24px;
				top: 30px;
				right: -20px;
				transform: translate(100%, -50%);
				outline: 0;

				h1 {
					margin: 0;
				}

				@media (min-width: $breakpoint-mid) {
					width: 360px;
				}

				button {
					height: auto;
					margin-top: 24px;
				}
			}
		}
	}

	.container-content {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		background-color: #f0f3fc;
		padding: 8px;
		border-radius: 0 0 6px 6px;
	}
}
</style>
